'use strict';
/**
 * 检查手机号是否正确
 * @param
 * @returns {Boolean}
 */
export function checkMobile(mobile) {
    const reg = new RegExp(/(^1[3|4|5|6|7|8|9]\d{9}$)|(^09\d{8}$)/);
    return reg.test(mobile);
}
/**
 * 检查邮箱是否正确
 * @param
 * @returns {Boolean}
 */
export function checkEmail(email) {
    const reg = new RegExp(/^[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*@[a-zA-Z0-9]+([-_.][a-zA-Z0-9]+)*\.[a-z]{2,}$/);
    return reg.test(email);
}
/**
 * 检查是否为number类型
 * @param
 * @returns {Boolean}
 */
export function checkNumber(number) {
    const regPos = new RegExp(/^\d+(\.\d+)?$/); //非负浮点数
    const regNeg = new RegExp(
        /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/,
    ); //负浮点数
    if (regPos.test(number) || regNeg.test(number)) {
        return true;
    } else {
        return false;
    }
}
/**
 * 检查是否为空
 * @param
 * @returns {Boolean}
 */
export function checkEmpty(string) {
    if (typeof string === 'undefined') {
        return true;
    }
    if (string === null) {
        return true;
    }
    if (string === '') {
        return true;
    }
    return false;
}

/**
 * 检测字符串是否有中文
 * @param
 * @returns {Boolean}
 */
export function containsChinese(value) {
    const reg = new RegExp(/.*[\u4e00-\u9fa5]+.*$/);
    return reg.test(value);
}




/**
 *
 * 获取连接参数
 * @param new Date()
 * @param sortType ascending descending
 * @returns String
 */
export function getQueryVariable(variable, url) {
    let href = window.location.href;
    if (url) {
        href = url
    }
    let newUrl = href.substring(href.indexOf("?") + 1, href.length);
    let vars = newUrl.split("&");
    for (let i = 0; i < vars.length; i++) {
        let pair = vars[i].split("=");
        if (pair[0] == variable) {
            return pair[1];
        }
    }
    return (false);
}

/**
 * 判断当前用户是不是会员
 */
export function isMember() {
    if (localStorage.getItem("isMember") != 1) {
        this.$Dialog
            .confirm({
                title: "提示",
                message: "您还不是会员，请先开通会员才能完成后续操作。"
            })
            .then(() => {
                // on confirm
                this.$router.push({
                    path: "/payEleCard"
                });
            })
            .catch(() => {
                // on cancel
            });
        return 0;
    } else {
        return 1;
    }
}


/**
 *
 * 判断当前浏览器是否是微信
 * @param new Date()
 * @param sortType ascending descending
 * @returns String
 */

export function isWeiXin() {
    var ua = navigator.userAgent.toLowerCase();
    let isWx = ua.match(/MicroMessenger/i) == "micromessenger";
    if (isWx) {
        let isWxWork = ua.match(/WxWork/i) == "wxwork";
        if (!isWxWork) {
            // 微信内浏览器
            return 1;
        } else {
            // 企业微信浏览器
            return 2;
        }
    } else {
        // web浏览器
        return 3;

    }
}